import styled from 'react-emotion'

const MainContainer = styled('div')`
  width: 1256px;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: 320px) and (max-width: 425px) {
    width: 93.75%;
  }
  @media (min-width: 426px) and (max-width: 767px) {
    width: 90%;
  }
  @media (min-width: 768px) and (max-width: 1200px) {
    width: 90%;
  }
  @media (min-width: 1200px) and (max-width: 1339px) {
    width: 1160px;
  }
`

export default {
  MainContainer
}



// WEBPACK FOOTER //
// ./src/components/core/PunePageResponsiveContainer/styledComponents.js